<script>
import CheckboxListItemField from '@phoenix/mixins/components/form/fields/CheckboxListItemField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [CheckboxListItemField],

  setup(props) {
    return useField(props);
  },

  computed: {
    checkboxClasses() {
      return {
        'sgphx-checkbox': this.isSgphx,
        'sgphx-checkbox--invalid': this.isSgphx && this.isInvalid,
        checkbox: !this.isSgphx,
        'checkbox--invalid': !this.isSgphx && this.isInvalid,
      };
    },
  },
};
</script>

<template>
  <div v-if="isSgphx" :class="checkboxClasses">
    <input
      :id="field.id"
      v-model="value"
      :value="field.value"
      :name="field.value"
      :data-cy="field.dataCy"
      :aria-describedby="ariaDescribedby"
      type="checkbox"
      class="sgphx-checkbox__input"
      is-sgphx
    />
    <label :for="field.id" class="sgphx-checkbox__label">{{ field.label }}</label>
  </div>

  <div v-else :class="checkboxClasses">
    <input
      :id="field.id"
      v-model="value"
      :value="field.value"
      :name="field.value"
      :data-cy="field.dataCy"
      :aria-describedby="ariaDescribedby"
      type="checkbox"
      class="checkbox__input"
    />
    <label :for="field.id" class="checkbox__label">{{ field.label }}</label>
  </div>
</template>
